/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import questions from '../../survey/questions';
import Switcher from '../../components/switcher';
import steps from '../../survey/steps';
import s from './index.module.scss';
import common from '../index.module.scss';
import InputStyle from './inputStyle/inputStyle';

function ValueAndUnitsHeight (props) {
	const { T } = useT();
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const { validationValues } = props;
	const { questionName } = props;
	const { stepName } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const currentStep = useSelector((state) => state.steps.currentStep);

	const savedQuestionValues = useSelector((state) => state.questions.savedAnswers[questionName]);
	const list = useSelector((state) => state.steps.list);

	const savedQuestionValuesValue = savedQuestionValues && savedQuestionValues.value && savedQuestionValues.value.value;
	const savedQuestionValuesUnits = savedQuestionValues && savedQuestionValues.units && savedQuestionValues.units.value;

	const [valueC, setValueC] = useState(savedQuestionValuesValue || '');
	const [valueF, setValueF] = useState(Math.floor(savedQuestionValuesValue / 12) || '');
	const [valueI, setValueI] = useState(savedQuestionValuesValue % 12 || '');
	const [isOnFocusF, setIsOnFocusF] = useState(false);
	const [isOnFocusI, setIsOnFocusI] = useState(false);
	const [isOnFocusC, setIsOnFocusC] = useState(false);
	const [units, setUnits] = useState(savedQuestionValuesUnits || '');
	const [isDoubleInput, setIsDoubleInput] = useState(true);
	const [validationWarning, setValidation] = useState(false);

	const bottom = !props.singleWarning ? T(`${questionName}_warning_bottom`) : T(`${questionName}_warning`);
	const top = !props.singleWarning ? T(`${questionName}_warning_top`) : T(`${questionName}_warning`);

	function validate () {
		if (units === 'ft' || savedQuestionValuesUnits === 'in') {
			if (valueF !== '' && valueF < 3) {
				setValidation(bottom);
				return;
			}

			if (valueF !== '' && valueF > 6 || valueI > 11) {
				setValidation(top);
				return;
			}

			if (valueF !== '') {
				setValidation(true);
			}
		}
		if (units === 'ft' || savedQuestionValuesUnits === 'in') {
			if (valueI !== '' && valueI < 1) {
				setValidation(bottom);
				return;
			}

			if (valueI !== '' && valueI > 11) {
				setValidation(top);
				return;
			}

			if (valueI !== '') {
				setValidation(true);
			}
		}
		if (units === 'cm') {
			setIsDoubleInput(false);
			if (valueC !== '' && valueC < validationValues[units].bottom) {
				setValidation(bottom);
				return;
			}

			if (valueC !== '' && valueC > validationValues[units].top) {
				setValidation(top);
				return;
			}

			if (valueC !== '') {
				setValidation(true);
			}
		}
	}

	useEffect(() => {
		validate();
	}, [units, valueF, valueI, valueC, currentStep, savedQuestionValuesValue]);

	function onChangeAction (e) {
		switch (e.target.id) {
		case 'heightF':
			setValueF(e.target.value.replace(/\D/, '').substring(0, 1));
			questions.setAnswer({
				questionName,
				answerName: 'value',
				answerValue: {
					value: `${(e.target.value * 12 + +valueI).toString().replace(/\D/, '')}`
				}
			});
			break;
		case 'heightI':
			setValueI(e.target.value.replace(/\D/, '').replace(/^0/, '').substring(0, 2));
			questions.setAnswer({
				questionName,
				answerName: 'value',
				answerValue: {
					value: `${(+e.target.value + +valueF * 12).toString().replace(/\D/, '')}`
				}
			});
			break;
		case 'heightC':
			setValueC(e.target.value.replace(/\D/, ''));
			questions.setAnswer({
				questionName,
				answerName: 'value',
				answerValue: {
					value: e.target.value.replace(/\D/, '')
				}
			});
			break;
		default: break;
		}
		e.target.value > 2 && e.target.value < 7 && document.querySelector('#heightI') && document.querySelector('#heightI').focus();
	}

	useEffect(() => {
		const completedCm = (valueC !== '' && units !== '' && validationWarning === true);
		const completedFt = (valueF !== '' && units !== '' && validationWarning === true);
		steps.setStepStatus({
			stepName,
			stepStatus: completedCm || completedFt
		});
	}, [units, valueF, valueI, valueC, list, currentStep, validationWarning]);

	function getCurrentUnitsValue () {
		return questions.getAnswers({ questionName }).units && questions.getAnswers({ questionName }).units.value || props.defaultUnits;
	}

	function changeUnits (unitsValue) {
		setUnits(unitsValue);

		questions.setAnswer({
			questionName,
			answerName: 'units',
			answerValue: {
				value: unitsValue === 'ft' ? 'in' : unitsValue
			}
		});
	}

	function onSwitcherChange (unitsValue) {
		if (unitsValue === units) return;
		changeUnits(unitsValue);
		valueI !== '' && unitsValue === 'ft' && setIsOnFocusI(true);

		if (unitsValue === 'cm') {
			setValueC('');
			setIsOnFocusC(true);
			questions.setAnswer({
				questionName,
				answerName: 'value',
				answerValue: {
					value: ''
				}
			});
		}
		if (unitsValue === 'ft') {
			setValueF('');
			setValueI('');
			questions.setAnswer({
				questionName,
				answerName: 'value',
				answerValue: {
					value: ''
				}
			});
		}

		questions.preventUnitsChanges({ name: stepName });

		if (unitsValue === props.defaultUnits) {
			setIsDoubleInput(true);
			document.querySelector('#heightF') && document.querySelector('#heightF').focus();
			window.userHeightNode = document.querySelector('#heightF');
		} else {
			setIsDoubleInput(false);
			document.querySelector('#heightC') && document.querySelector('#heightC').focus();
			window.userHeightNode = document.querySelector('#heightC');
		}
	}

	useEffect(() => {
		setUnits(getCurrentUnitsValue());
		changeUnits(getCurrentUnitsValue());
	}, []);

	useEffect(() => {
		setUnits(getCurrentUnitsValue());
		changeUnits(getCurrentUnitsValue());
	}, [currentStep]);

	function actionOnFocus (e) {
		if (e.target.id === 'heightF') {
			setIsOnFocusF(true);
		} else if (e.target.id === 'heightI') {
			setIsOnFocusI(true);
		}

		setTimeout(() => {
			document.documentElement.scrollTop = -300;
		}, 50);
	}

	return (
		<div data-prevent-from-blur className={`${common.step} ${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<div className={common.stepTitle}>{T(questionName)}</div>

			<Switcher
				className={s.switcher}
				value1={props.units[0]}
				value2={props.units[1]}
				currentValue={getCurrentUnitsValue()}
				actionOnChange={onSwitcherChange}
				disableFromFocus={!isThisCurrentStep}
			/>
			<InputStyle
				actionOnFocus={actionOnFocus}
				onChangeAction={onChangeAction}
				isOnFocusF={isOnFocusF}
				isOnFocusI={isOnFocusI}
				isOnFocusC={isOnFocusC}
				valueF={valueF}
				valueI={valueI}
				valueC={valueC}
				isThisCurrentStep={isThisCurrentStep}
				isDoubleInput={isDoubleInput}
				inputStyle={props.inputStyle}
			/>
			{
				validationWarning &&
        (
        	<div className={s.warning}>
        		{validationWarning}
        	</div>
        )
			}
		</div>
	);
}

export default ValueAndUnitsHeight;
